export default __webpack_public_path__ + "static/media/WarmonkPassage.5661219b.jpg";